class SanjarStyleStudio extends HTMLElement {
  connectedCallback() {
    this.controller?.abort(); this.controller = new AbortController();
    this.addEventListener('click', event => {
      const open = event.target.closest('[data-studio-open]');
      if (open) this.querySelector(`#${CSS.escape(open.dataset.studioOpen)}`)?.showModal();
      const close = event.target.closest('[data-studio-close]');
      if (close) close.closest('dialog').close();
      if (event.target instanceof HTMLDialogElement) {
        const bounds = event.target.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
      }
    }, {signal:this.controller.signal});
    this.querySelector('[data-finder-form]')?.addEventListener('submit', event => {
      for (const field of event.target.elements) if (field.name && field.value === '') field.disabled = true;
    }, {signal:this.controller.signal});
    this.querySelector('[data-finder-form]')?.addEventListener('input', event => {
      for (const field of event.currentTarget.elements) field.disabled = false;
    }, {signal:this.controller.signal});
  }
  disconnectedCallback() {this.controller?.abort();}
}
class SanjarConsultation extends HTMLElement {
  connectedCallback() {
    this.controller?.abort(); this.controller = new AbortController();
    const form = this.querySelector('form'), link = this.querySelector('[data-consult-request]');
    const date = form.elements.date, time = form.elements.time;
    const today = new Intl.DateTimeFormat('en-CA',{timeZone:'Asia/Kolkata',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date());
    date.min = today;
    const update = () => {
      date.setCustomValidity(''); time.setCustomValidity('');
      if (date.value && time.value && new Date(`${date.value}T${time.value}:00+05:30`).getTime() <= Date.now()) time.setCustomValidity(this.dataset.past);
      const d = this.dataset;
      const lines = [d.intro,`${d.nameLabel}: ${form.elements.name.value.trim()}`,`${d.dateLabel}: ${date.value}`,`${d.timeLabel}: ${time.value}`];
      if (form.elements.notes.value.trim()) lines.push(`${d.notesLabel}: ${form.elements.notes.value.trim()}`);
      if (d.productTitle) lines.push(`${d.productLabel}: ${d.productTitle}`, d.productUrl);
      link.href = `https://wa.me/${d.phone.replace(/\D/g,'')}?text=${encodeURIComponent(lines.join('\n'))}`;
    };
    this.addEventListener('input',update,{signal:this.controller.signal});
    link.addEventListener('click',event=>{update();if(!form.reportValidity())event.preventDefault();},{signal:this.controller.signal});
    form.addEventListener('submit',event=>{event.preventDefault();link.click();},{signal:this.controller.signal});
    update();
  }
  disconnectedCallback(){this.controller?.abort();}
}
if(!customElements.get('sanjar-style-studio'))customElements.define('sanjar-style-studio',SanjarStyleStudio);
if(!customElements.get('sanjar-consultation'))customElements.define('sanjar-consultation',SanjarConsultation);

class SanjarSareeQuiz extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort = new AbortController();
    this.form = this.querySelector('[data-quiz-form]');
    this.steps = [...this.querySelectorAll('[data-quiz-step]')];
    this.index = 0;
    const signal = this.abort.signal;
    this.form.addEventListener('submit', event => {
      event.preventDefault();
      if (this.busy || !this.validStep()) return;
      if (this.index < this.steps.length - 1) this.showStep(this.index + 1, true);
      else this.results();
    }, {signal});
    this.querySelector('[data-quiz-back]').addEventListener('click', () => this.showStep(this.index - 1, true), {signal});
    this.querySelector('[data-quiz-skip]').addEventListener('click', () => {
      this.steps[this.index].querySelector('select,input').value = '';
      if (this.index < this.steps.length - 1) this.showStep(this.index + 1, true);
      else this.results();
    }, {signal});
    this.querySelector('[data-quiz-edit]').addEventListener('click', () => this.showStep(0, true), {signal});
    this.showStep(0);
  }
  disconnectedCallback() { this.abort?.abort(); this.request?.abort(); }
  validStep() { return this.steps[this.index].querySelector('select,input').reportValidity(); }
  showStep(index, focus = false) {
    if (this.busy) return;
    this.index = Math.max(0, Math.min(index, this.steps.length - 1));
    this.querySelector('[data-quiz-questions]').hidden = false;
    this.querySelector('[data-quiz-result]').hidden = true;
    this.querySelector('[data-quiz-result-actions]').hidden = true;
    this.querySelector('[data-quiz-status]').textContent = '';
    this.steps.forEach((step, n) => { step.hidden = n !== this.index; step.querySelector('select,input').disabled = n !== this.index; });
    this.querySelector('[data-quiz-count]').textContent = this.dataset.stepLabel.replace('__current__', this.index + 1).replace('__total__', this.steps.length);
    const progress = this.querySelector('[data-quiz-progress]'); progress.max = this.steps.length; progress.value = this.index + 1;
    this.querySelector('[data-quiz-back]').disabled = this.index === 0;
    this.querySelector('[data-quiz-next]').textContent = this.index === this.steps.length - 1 ? this.dataset.resultsLabel : this.dataset.nextLabel;
    if (focus) this.steps[this.index].querySelector('select,input').focus();
  }
  async results() {
    if (this.busy || !this.validStep()) return;
    this.request?.abort(); this.request = new AbortController();
    const url = new URL(this.form.action, location.origin);
    url.searchParams.set('filter.v.availability', '1');
    for (const step of this.steps) {
      const field = step.querySelector('select,input');
      if (field.value !== '') url.searchParams.set(field.name, field.value);
    }
    this.querySelector('[data-quiz-all]').href = url.href;
    url.searchParams.set('section_id', 'sanjar-quiz-results');
    this.busy = true; this.setAttribute('aria-busy', 'true');
    this.querySelectorAll('[data-quiz-next],[data-quiz-back],[data-quiz-skip]').forEach(button => { button.disabled = true; });
    const status = this.querySelector('[data-quiz-status]'); status.textContent = this.dataset.loading;
    try {
      const response = await fetch(url, {signal:this.request.signal});
      if (!response.ok) throw new Error();
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = doc.querySelector('[data-quiz-results]');
      if (!content || !content.querySelector('h3')) throw new Error();
      const result = this.querySelector('[data-quiz-result]');
      result.replaceChildren(document.importNode(content, true)); result.hidden = false;
      this.querySelector('[data-quiz-questions]').hidden = true;
      this.querySelector('[data-quiz-result-actions]').hidden = false;
      status.textContent = ''; result.focus();
    } catch (error) { if (error.name !== 'AbortError') status.textContent = this.dataset.error; }
    finally {
      this.busy = false; this.removeAttribute('aria-busy');
      this.querySelectorAll('[data-quiz-next],[data-quiz-back],[data-quiz-skip]').forEach(button => { button.disabled = false; });
      this.querySelector('[data-quiz-back]').disabled = this.index === 0;
    }
  }
}
if (!customElements.get('sanjar-saree-quiz')) customElements.define('sanjar-saree-quiz', SanjarSareeQuiz);
